/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Import_Subtitles_Start_ToastInputs */



/**
* | output |
* | --- |
* | "Importing subtitle events..." |
*
* @param {Editor_Import_Subtitles_Start_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_import_subtitles_start_toast = /** @type {((inputs?: Editor_Import_Subtitles_Start_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Import_Subtitles_Start_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des evenements de sous-titres...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelereignisse werden importiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione degli eventi dei sottotitoli...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт событий субтитров...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando eventos de subtítulos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导入字幕事件...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕イベントをインポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक इवेंट आयात किए जा रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando eventos de legenda...")
	return /** @type {LocalizedString} */ ("Importing subtitle events...")
});